import { render } from "./InactivityDisconnect.vue?vue&type=template&id=5860d63d"
import script from "./InactivityDisconnect.vue?vue&type=script&lang=js"
export * from "./InactivityDisconnect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__